import { render, staticRenderFns } from "./QuestionPaperCatagory.vue?vue&type=template&id=649ae24d&"
import script from "./QuestionPaperCatagory.vue?vue&type=script&lang=js&"
export * from "./QuestionPaperCatagory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports